import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH.
// redirect_uri is rebuilt from window.location.origin and sent back to /api/auth/google/exchange
// so Google can verify it matches the one used to obtain the `code`.

export default function GoogleAuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;

    const url = new URL(window.location.href);
    const code = url.searchParams.get("code");
    const error = url.searchParams.get("error");

    if (error) {
      toast.error(`Google: ${error}`);
      nav("/login", { replace: true });
      return;
    }
    if (!code) {
      nav("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const redirectUri = window.location.origin + "/auth/google";
        const { data } = await api.post("/auth/google/exchange", { code, redirect_uri: redirectUri });
        setUser(data);
        toast.success("Accesso effettuato con Google");
        // clean URL & go feed
        window.history.replaceState(null, "", "/feed");
        nav("/feed", { replace: true });
      } catch (err) {
        const detail = err?.response?.data?.detail;
        toast.error(formatApiError(detail) || "Login Google non riuscito. Riprova o usa email/password.");
        nav("/login", { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="flex flex-col items-center gap-4 text-gray-700" data-testid="google-callback-loading">
        <div className="w-10 h-10 border-2 border-[#E11D48] border-t-transparent rounded-full animate-spin" />
        <div className="text-sm uppercase tracking-wider font-bold">Accesso Google in corso...</div>
      </div>
    </div>
  );
}
